import * as React from "react";
const SvgAdd = props => <svg width="inherit" height="inherit" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 3V21M3 12H21" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgAdd;